import { InteliaxChatConfig } from "./data";

// chatApi LOCAL: "https://localhost:5301/"" | DEV: "https://dev-chat-app.tlv7.com.br/"
export const environment: InteliaxChatConfig = {
  chatApi: "https://dev-chat-app.tlv7.com.br/",
  catalogo: null,
  production: true
}

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
